// Toplu Cari Ekle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.bulkAdd';

export const accountBulkAddGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Toplu cari nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Bu pencere, aynı yapıda birden fazla cari hesabı tek seferde oluşturur ve kayıt işini hızlandırır.'),
  regionLabels: {
    body: t(`${G}.regions.body`, 'Ayarlar ve isimler'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Cari grubu seçin'),
      text: t(`${G}.s1.text`, 'Cari Grup seçimi zorunludur. Seçtiğiniz grup bu işlemde eklenen tüm carilere atanır. Listede olmayan grubu yanındaki + ile ekleyebilirsiniz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Eksi bakiye kuralını belirleyin'),
      text: t(`${G}.s2.text`, '"Cari hesap bakiyesi eksiye düşemesin" işaretlenirse kural, bu işlemde eklenen tüm yeni carilere birlikte uygulanır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Cari adlarını yazın'),
      text: t(`${G}.s3.text`, 'Her satıra bir cari adı yazın; her satır bir cari olarak eklenir. Boş satırlar dikkate alınmaz.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. "Toplu Kaydet"e basın'),
      text: t(`${G}.s4.text`, 'Sistem yazdığınız adları mevcut carilerle karşılaştırır. Aynı adla kayıtlı cari tekrar oluşturulmaz, kendiliğinden atlanır; yalnız yeni adlar eklenir.'),
      tips: [
        t(`${G}.s4.tip1`, 'İşlem bitince kaç carinin eklendiği, kaçının atlandığı ve hangilerinde hata olduğu özet olarak gösterilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Eksik bilgileri sonradan tamamlayın'),
      text: t(`${G}.s5.text`, 'Toplu ekleme, temel cari kaydını hızlıca açmak içindir. İletişim, vergi, adres ve risk bilgilerini daha sonra cari kartından güncelleyebilirsiniz.'),
    },
  ],
});
